import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const ContactSupportHistory = lazyRouteComponent(() => import('@/_instructor/contact-support/history'));

export const Route = createFileRoute('/_instructor/support/history')({
  component: () => renderInstructorPage(ContactSupportHistory),
});
